const DAI_AGENT = 'dai_agent'
const DOCUMENT_AGENT = 'document_agent'
const POP_AGENT = 'pop_agent'
const POP_DRAFT_AGENT = 'pop_draft_agent'
const POP_REVIEW_AGENT = 'pop_review_agent'
const WORKFLOW_AGENT = 'workflow_agent'
const WORKFLOW_PROCESS_READER_AGENT = 'workflow_process_reader_agent'
const DOCUMENT_CREATION_AGENT = 'document_creation_agent'
const DOCUMENT_UPDATE_AGENT = 'document_update_agent'
const POP_DOCUMENT_CREATION_AGENT = 'pop_document_creation_agent'
const GOVERNANCE_PROJECT_COPILOT_AGENT = 'governance_project_copilot_agent'
const GOVERNANCE_DOCUMENT_CREATION_AGENT = 'governance_document_creation_agent'

const names = {
  [DAI_AGENT]: 'Assistente DAI',
  [DOCUMENT_AGENT]: 'Agente de Documentos',
  [POP_AGENT]: 'Agente de POP',
  [POP_DRAFT_AGENT]: 'Agente de Rascunho de POP',
  [POP_REVIEW_AGENT]: 'Agente de Revisão de POP',
  [POP_DOCUMENT_CREATION_AGENT]: 'Agente de criação de POP',
  [WORKFLOW_AGENT]: 'Agente de Fluxo de Trabalho',
  [WORKFLOW_PROCESS_READER_AGENT]: 'Agente Leitor de Processo',
  [DOCUMENT_CREATION_AGENT]: 'Agente de Criação de Documentos',
  [DOCUMENT_UPDATE_AGENT]: 'Agente de Atualização de Documentos',
  [GOVERNANCE_PROJECT_COPILOT_AGENT]: 'Agente de Governança',
  [GOVERNANCE_DOCUMENT_CREATION_AGENT]:
    'Agente de Criação de Documentos de Governança',
}

export default {
  DAI_AGENT,
  DOCUMENT_AGENT,
  POP_AGENT,
  POP_DRAFT_AGENT,
  POP_REVIEW_AGENT,
  POP_DOCUMENT_CREATION_AGENT,
  WORKFLOW_AGENT,
  WORKFLOW_PROCESS_READER_AGENT,
  DOCUMENT_CREATION_AGENT,
  DOCUMENT_UPDATE_AGENT,
  GOVERNANCE_PROJECT_COPILOT_AGENT,
  GOVERNANCE_DOCUMENT_CREATION_AGENT,
  names,
}
